import styles from '../../page.module.scss';
import asterix from '../../assets/decos/asterix.svg';
import bgShape from '../../assets/decos/bg-shape-red.svg';
import AuthorCard from './cards/AutorCard';

interface Author {
  mainTitle: string;
  cardImage: string;
  description: any;
  published?: boolean;
}

interface AutoresSectionProps {
  authors: Author[];
  books: any[];
  loading?: boolean; // Nueva prop para manejar el estado de carga
}

const AutoresSection: React.FC<AutoresSectionProps> = ({ authors, books, loading = false }) => {
  return (
    <div id="autores" className={styles.marginBottomSection}>
      <section className={styles.autoresContainer}>
        <div className={styles.autoresContent}>
          <div>
            <img className={styles.asterixAutores} src={asterix.src} alt="imagen decorativa" />
            <h2 className={styles.title}>NUESTROS AUTORXS</h2>
          </div>
          <img
            className={styles.autoresImage}
            src={'/assets/images/editorial.png'}
            alt="image de un autor ideal"
          />
        </div>
        <div className={styles.flyerContainer}>
          {!loading
            ? [...authors].reverse().map(
                (author: Author, index: number) =>
                  author.published && (
                    <div key={index} className={styles.autorCardContainer}>
                      <AuthorCard
                        description={author.description}
                        mainTitle={author.mainTitle}
                        cardImage={author.cardImage}
                        books={books}
                      />
                    </div>
                  )
              )
            : // Skeleton loaders para los autores
              [1, 2, 3, 4, 5, 6].map((_, index: number) => (
                <div key={index} className={styles.autorCardContainer}>
                  <div
                    className={`${styles.autorCard} ${styles.cardLoader} ${styles.autorCardLoader}`}
                  ></div>
                </div>
              ))}
        </div>
      </section>
      <img className={styles.bgShape} src={bgShape.src} alt="imagen de decorativa de fondo" />
    </div>
  );
};

export default AutoresSection;
